<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-06 10:21:54
 * @Description: 单处登录
-->
<template>
	<div class="simply_login">
		<div class="container">
			<a-result status="warning" :title="$t('login.simply_login.tip')">
				<template #extra>
					<div class="footer">
						<a-button @click="goLogin">{{ $t("base.btn.back_login") }}</a-button>
						<a-button type="primary" @click="handleOk">{{ $t("base.btn.continue_login") }}</a-button>
					</div>
				</template>
			</a-result>
		</div>
	</div>
</template>

<script>
import { commonMethods } from "../mixins/common";
import { commonAPI } from "@/apis";

export default {
	name: "SimplyLogin",
	mixins: [commonMethods],
	data() {
		return {
			before_login: {},
		};
	},
	beforeRouteEnter(to, form, next) {
		next((vm) => {
			// 判断是否可进入该路由
			let before_login = JSON.parse(sessionStorage.getItem("BEFORE_LOGIN"));
			if (!before_login || !before_login.noSingleLogin) {
				vm.$router.replace({ path: form.path });
			} else {
				vm.before_login = { ...before_login };
			}
		});
	},
	created() {},
	methods: {
		async handleOk() {
			const { code, message } = await commonAPI.getAction("/users/Offline");
			if (code == 0) {
				this.$message.success(message);
				this.before_login.noSingleLogin = false;
				sessionStorage.setItem("BEFORE_LOGIN", JSON.stringify(this.before_login));
				this.jumpComputed();
			} else {
				this.$message.error(message);
			}
		},
	},
};
</script>

<style lang="less" scoped>
.simply_login::v-deep {
	width: 100%;
	height: 100%;
	padding-top: 35px;
	.container {
		max-width: 800px;
		width: 80%;
		margin: 0 auto;
		background-color: #fff;
		padding: 30px 0;
		border-radius: 20px;

		.footer {
			text-align: center;
			margin-top: 10px;
			.ant-btn + .ant-btn {
				margin-left: 40px;
			}
		}
	}
}
</style>
